export const apiBaseUrl =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? "http://localhost/api"
    : "https://app01.lib.eduhk.hk/lem/api";
export const captchaUrl =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? "http://localhost/captcha/api/flat"
    : "https://app01.lib.eduhk.hk/lem/captcha/api/flat";
export const grecaptchaSiteKey = "6LctIgIiAAAAAHOYNkjebk7gdRxmCuB8UX3Qw8oB";